import React, { useState } from "react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import { partsVideos } from "./components/componentData/part_iframes";

export default function VideoCarousel() {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const length = partsVideos.length;

  const prevSlide = () => {
    setCurrentVideoIndex(
      currentVideoIndex === 0 ? length - 1 : currentVideoIndex - 1
    );
  };
  const nextSlide = () => {
    setCurrentVideoIndex(
      currentVideoIndex === length - 1 ? 0 : currentVideoIndex + 1
    );
  };

  if (!Array.isArray(partsVideos) || partsVideos.length <= 0) {
    return null;
  }

  return (
    <>
      <section className="video-carousel">
        <FaLessThan
          className="left-arrow-video"
          onClick={prevSlide}
          color={"yellow"}
        />
        <FaGreaterThan
          className="right-arrow-video"
          onClick={nextSlide}
          color={"yellow"}
        />
        {partsVideos.map((item, index) => {
          console.log(item.video);
          return (
            <div
              className={index === currentVideoIndex ? "slide-active" : "slide"}
              key={index}
            >
              {index === currentVideoIndex && <div>{item.video}</div>}
            </div>
          );
        })}
      </section>
    </>
  );
}
